import { useContext, useState } from 'react';
import { Dialog, Button, IconButton, Typography, Link } from '@material-ui/core';
import SelectFantasyLeagueDropdown from './SelectFantasyLeagueDropdown';
import { DataSpaceViewContext } from '../../my_dataspaces/context/DataSpaceViewContext';
import SnackbarAlertContext from '../../../context/SnackbarAlertContext';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../../../theme';
import CloseIcon from '@material-ui/icons/Close';

const SelectFantasyLeagueModal = ({ isOpen, onClose, onSuccess }) => {
	const dataSpaceViewContext = useContext(DataSpaceViewContext);
	const snackbarAlertContext = useContext(SnackbarAlertContext);

	const [selectedFantasyLeague, setSelectedFantasyLeague] = useState();

	const handleFantasyLeagueChange = (event) => {
		setSelectedFantasyLeague(event.target.value);
	};

	const isOptionDisabled = (fantasyLeague) => {
		const fantasyLeagueDataset = dataSpaceViewContext.dataSpace.datasets.find((dataset) =>
			['Yahoo! Fantasy Sports', 'Fantrax'].includes(dataset.tags.api),
		);

		return (
			fantasyLeague.api !== fantasyLeagueDataset?.tags.api || fantasyLeague.sport !== fantasyLeagueDataset?.tags.sport
		);
	};

	const cloneDataSpaceClickHandler = () => {
		if (!selectedFantasyLeague) {
			snackbarAlertContext.setSnackbarAlert({
				msg: 'Please select a fantasy league.',
				severity: 'error',
			});
			return;
		}
		setSelectedFantasyLeague(undefined);
		onSuccess(selectedFantasyLeague);
	};

	const closeModalHandler = () => {
		setSelectedFantasyLeague(undefined);
		onClose();
	};

	return (
		<ThemeProvider theme={theme}>
			<Dialog open={isOpen} fullWidth>
				<IconButton className="close-button" aria-label="close" onClick={closeModalHandler}>
					<CloseIcon sx={{ fontSize: '1rem' }} />
				</IconButton>

				<Typography variant="h3" align="center" sx={{ my: 1 }}>
					Select a Fantasy League
				</Typography>

				<Typography variant="body1" align="center" sx={{ mb: 3 }}>
					This DataSpace contains data from the author's fantasy league. Please select your own fantasy league to use in
					its place.
				</Typography>

				{isOpen && (
					<SelectFantasyLeagueDropdown
						selectedFantasyLeague={selectedFantasyLeague}
						handleFantasyLeagueChange={handleFantasyLeagueChange}
						isOptionDisabled={isOptionDisabled}
					/>
				)}

				<Button
					type="submit"
					color="primary"
					variant="contained"
					onClick={cloneDataSpaceClickHandler}
					sx={{ mt: 2 }}
					disabled={!selectedFantasyLeague}
				>
					Add DataSpace to My Account
				</Button>

				<Typography variant="footnote" align="center" sx={{ mt: 2 }}>
					Don't have a fantasy account? Check out our{' '}
					<Link href="/app?route=communityDataSpaces">Community Marketplace</Link>.
				</Typography>
			</Dialog>
		</ThemeProvider>
	);
};

export default SelectFantasyLeagueModal;
